module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='	<div class="timeline-item__details">\n		<div class="timeline-item__date">'+
((__t=( formatTime(obj.createdAt, 'Do of MMMM, HH:mm') ))==null?'':__t)+
'</div>\n		<div class="timeline-item__user">'+
((__t=( getOwnerName() ))==null?'':__t)+
'</div>\n\n	</div>\n<div class="timeline-item__content">\n	<div class="timeline-item-content__title">'+
((__t=( obj.title ))==null?'':__t)+
'</div>\n	<div class="timeline-item-content__body">'+
((__t=( obj.body ))==null?'':__t)+
'</div>\n\n	<div class="timelinte-item-content__actions">	</div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-events/show/templates/timeline-list-item.html
// module id = 423
// module chunks = 0